import { State } from "./state";
import { MutationTree } from "vuex";

const SET_FILTER = (state: State, payload: any) => {
  state.filter = payload;
};
export default <MutationTree<State>>{
  SET_FILTER,
};
